<template>
  <!-- 新增盘口展示 头部-->
  <div id="transcc_new_NewTransccTopLine">
    <el-row justify="space-between" align="center" class="header-row">
          <!-- <el-col class="good_cell-1">
            <div v-show="isShowCoinfobtn" class="good_icon" @click="showCoinfo"><img src="./img/search.svg" alt=""></div>
          </el-col> -->
          <el-row class="good_cell_left" justify="space-between" align="center">
            <el-col class="good_cell-2">
              <div class="good_icon">{{ commodityCode }}</div>
            </el-col>
            <span style="margin:0 13px;font-size:14px;font-weight:normal;color:#e0e0e0;line-height:14px">|</span>
            <el-col class="good_cell-3">
              <!-- <div class="good_name">{{ item }}</div>  -->
                <el-select
                  v-model="selectItemNew.symbol"
                  popper-class="_ccStyle"
                  :popper-append-to-body="true"
                  @change="changeCode"
                  size="small"
                  placeholder="显示全部"
                >
                  <el-option
                    v-for="item in commodityOptions"
                    :key="item.symbolCode"
                    :label="item.symbol"
                    :value="item.symbol"
                  >
            </el-option>
          </el-select>
            </el-col>
            <el-col>
              <div class="btn" @click="goPageF10">F10</div>
            </el-col>
          </el-row>
          <div class="good_cell_center">
            <el-col class="good_cell-4">
              <div class="good_msg">
                <span class="good_msg_t">最新价</span>
                <span class="good_msg_v" :style="{color:selectItem.closeToClearColor}">{{ nowClosePrice }}</span>
              </div>
            </el-col>
            <el-col class="good_cell-5">
                <div class="good_msg">
                  <span class="good_msg_t">涨跌幅</span>
                  <span class="good_msg_v" :style="{color:selectItem.quotechangeColor}">{{ selectItem.quotechange | addSign }}</span>
              </div>
            </el-col>
            <el-col class="good_cell-5">
              <div class="good_msg">
                <span class="good_msg_t">涨停价</span>
                <span class="good_msg_v" style="color:#d94066;">{{ Number(CommodityHighLow.high).toFixed(selectItem.coinDigitalNum) }}</span>
              </div>
            </el-col>
            <el-col class="good_cell-5">
              <div class="good_msg">
                <span class="good_msg_t">跌停价</span>
                <span class="good_msg_v" style="color:#41B37D;">{{ Number(CommodityHighLow.low).toFixed(selectItem.coinDigitalNum) }}</span>
              </div>
            </el-col>
            <el-col v-if="isShowCc" class="good_cell-7">
              <div class="good_msg">
                <span class="good_msg_t">仓差</span>
                <!-- :class="selectItem.warehouseBad>0?'blood':selectItem.warehouseBad<0?'green':''" -->
                <span v-if="APP_WINNY_NAME === '尚志汇农'" class="good_msg_v big" style="color:#c7c7c7;">{{ selectItem.warehouseBad * 2 }}</span>
                <span v-else class="good_msg_v big" style="color:#c7c7c7;">{{ selectItem.warehouseBad }}</span>
              </div>
            </el-col>
          </div>
          <!-- <el-col class="good_cell-6">
            <div class="good_msg">
              <span class="good_msg_t">涨跌</span>
              <span class="good_msg_v" :style="{color:selectItem.closeToClearColor}">{{ Number(selectItem.quote).toFixed(selectItem.coinDigitalNum) }}</span>
            </div>
          </el-col> -->
         
          <el-col>
            <el-row align="center">
              <!-- <el-col :span="6" class="item-align-center">
                <div class="btn">f10</div>
              </el-col> -->
              <div class="good_cell_right">
                  <el-col :span="8">
                    <div v-if="marketStatusInNewTopline!='--'" class="marketType">{{ marketStatusInNewTopline }}</div>
                  </el-col>
                  <el-col v-if="marketStatusInNewTopline!='--'" :span="marketStatusInNewTopline=='--'?22:14">
                    <div class="time" style="text-align:right">{{ Number(systemTimeGetter)|dateFormate }}</div>
                  </el-col>
              </div>
            
            </el-row>
          </el-col>
    </el-row>
    <el-drawer
      class="coinfoWrap"
      direction="ltr"
      :visible.sync="isCionInfo"
      :before-close="handleClose"
      :show-close="false"
      width="500px"
    >
      <CoinInfo @confirm="changItem" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="isCionInfo = false">取 消</el-button>
        <el-button type="primary" @click="isCionInfo = false">确 定</el-button>
      </span>
    </el-drawer>
  </div>
</template>
<script>
/*global protocol http*/
import { mapGetters } from 'vuex'
import CoinInfo from '../coininfo/CoinInfo.vue'
export default {
  components: {
    CoinInfo
  },
  data() {
    return {
      APP_WINNY_NAME: window.g.APP_WINNY_NAME,
      currentUrl: '/quotationList',
      commodityName: null,
      selfItem: null,
      symbol: '--',
      selectItemNew: {},
      commodityCode: '--',
      reloadTimer: null,
      isCionInfo: false,
      isShowCc: false, // 根据宽度判断是否展示仓差
      isShowCoinfobtn: false,
      isStartNum: 0 // 判断是否是首次进入页面
    }
  },
  computed: {
    /* eslint-disable vue/no-side-effects-in-computed-properties */
    ...mapGetters(['commodityStrategyGetter', 'CommodityHighLowGetter', 'marketDetails', 'systemTimeGetter', 'marketStatusInNewTopline', 'f10click', 'sessionInfoGetter']),
    isLogin() {
      if (
        this.sessionInfoGetter &&
        this.sessionInfoGetter['sessionStr'] &&
        this.sessionInfoGetter['userId']
      ) {
        return true
      }
      return false
    },
     commodityOptions() {
          return this.$store.state.hqData.marketDetails
      },
    item() {
      const item = this.$store.state.hqData.item.symbol
      //  console.log('1111111111',this.$store.state.hqData);
      if (item) {
        this.selfItem = this.$store.state.hqData.item
        this.symbol = this.$store.state.hqData.item.symbolId
        this.commodityCode = this.$store.state.hqData.item.commodityCode
        return this.$store.state.hqData.item.symbol
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          this.selfItem = this.$store.state.hqData.marketDetails[0]
          this.symbol = this.$store.state.hqData.marketDetails[0].symbolId
          this.commodityCode = this.$store.state.hqData.marketDetails[0].commodityCode
          return this.$store.state.hqData.marketDetails[0].symbol
        } else {
          this.selfItem = null
          this.symbol = '--'
          this.commodityCode = '--'
          return '--'
        }
      }
    },
    marketDetails() {
      const marketDetails = this.$store.state.hqData.marketDetails
      if (marketDetails.length > 0) {
        return marketDetails
      } else {
        return [
          {
            close: '0.00',
            quotechangeColor: 'white',
            quotechange: '0.00%',
            high: '0',
            low: '0',
            amount: '0'
          }
        ]
      }
    },
    
    selectItem() {
      const item = this.$store.state.hqData.item.symbol
      if (item) {
        for (let index = 0; index < this.$store.state.hqData.marketDetails.length; index++) {
          const element = this.$store.state.hqData.marketDetails[index]
          if (this.$store.state.hqData.item.symbolId == element.symbolId) {
            return element
          }
        }
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0]
        } else {
          return {
            close: 0.00,
            quotechangeColor: 'white',
            quotechange: 0.00,
            high: 0,
            low: 0,
            amount: 0,
            symbolId: '--',
            clearPrice: 0,
            numStr: /^(\d+)\.(\d{0,2}).*$/,
            coinDigitalNum: 2,
            quantityNum: 2, // 数量,
            quantityStr: /^(\d+)\.(\d{0,2}).*$/ // 数量
          }
        }
      }
      return {}
    },
    data() {
      const item = this.$store.state.hqData.item.symbolId
      if (item) {
        return item
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].symbolId
        } else {
          return '--'
        }
      }
    },
    nowClosePrice() {
      return Number(this.selectItem.close).toFixed(this.selectItem.coinDigitalNum)
    },
    tradeCurrency() { // 交易货币
      if (this.item.indexOf('/')) {
        const currencyArr = this.item.split('/')
        return currencyArr[0]
      } else {
        return this.item
      }
    },
    CommodityHighLow() {
      return this.CommodityHighLowGetter
    }
  },
  watch: {
    f10click() {
      this.goPageF10()
    },
    item:{
      handler(){
        this.selectItemNew.symbol = this.item
      },
      immediate:true
    },
    selfItem(val, oldVal) {
      //  'val.symbolId !== oldVal?.symbolId'防止刷新时请求两次状态
      if (val && val.symbolId !== oldVal?.symbolId && this.item != '--' && this.isStartNum !== 0) {
        this.findCommodityHighLow()
      }
    },
    nowClosePrice(val, oldVal) {
      document.title = val + ' ' + this.item + ' ' + window.g.APP_TITLE_CLICK
    },
    marketStatusInNewTopline(val, oldVal) {
      if ((oldVal == '--' || oldVal == '闭市') && val == '开市中' && this.selfItem && this.isStartNum !== 0) {
        this.findCommodityHighLow()
      }
    }
  },
  created() {
    this.judeWidth()
    window.addEventListener('resize', () => {
      this.judeWidth()
    })
    this.$nextTick(() => {
      this.isShowCoinfobtn = true
    })
  },
  mounted(){
    if (window.location.href.indexOf('quotationList') !== -1) {
      this.currentUrl = '/quotationList'
    } else {
      this.currentUrl = '/transCC'
    }
    // 触发item计算属性
    const item = this.item
    this.findCommodityHighLow()
  },
  destroyed() {
    window.removeEventListener('resize', () => {
      this.judeWidth()
    })
  },
 
  methods: {
    judeWidth() {
      // 判断是否展示仓差
      const _this = this
      const widthH = document.documentElement.clientWidth || document.body.clientWidth
      if (widthH < 1360) {
        _this.isShowCc = false
      } else {
        _this.isShowCc = true
      }
    },
    goPageF10() {
      this.$router.push('/pagef10')
    },
    changItem() {
      this.isCionInfo = false
    },
    showCoinfo() {
      // 展示coinInfo
      this.isCionInfo = true
    },
    handleClose() {
      this.isCionInfo = false
    },
    getTop(symbolId) {
      // 切换商品获取top用于行情列表页销售1对应买价和买量的变化
      hqProtocol.param_top.symbol = symbolId // this.$store.state.hqData.marketDetails[0].symbolId
      if (symbolId && symbolId != '--') {
        hqWs.send(hqProtocol.param_top)
        if (this.reloadTimer) {
          clearInterval(this.reloadTimer)
          this.reloadTimer = null
        }
        this.reloadTimer = setTimeout(() => {
          if (symbolId && symbolId != '--') {
            hqWs.send(hqProtocol.param_top)
          }
        }, window.g.TOP_REFRESH_TIME ? window.g.TOP_REFRESH_TIME : 1000)
      }
    },
    changeCode(symbol) {
      this.selectTradeType = '1' // 解锁交易组件刷新
      const codeOption = JSON.parse(JSON.stringify(this.commodityOptions))
      codeOption.forEach(element => {
        if (element.symbol === symbol) {
          this.selectItemNew = element
          this.$store.commit('item', element)
          localStorage.setItem('commName', element.symbol)
          if (this.currentUrl === '/quotationList') {
            this.getTop(element.symbolId)
          }
          return
        }
      })
    },
    // 商品涨停跌停价查询
    findCommodityHighLow() {
      protocol.findCommodityHighLow.data.commodityId = this.symbol
      http.gPost(protocol.findCommodityHighLow).then(response => {
        if (response.data) {
          if (response.data && response.data.code == '0') {
            // 共享到全局
            this.$store.commit('setCommodityHighLow', response.data.value)
            setTimeout(() => { // 延时赋值侦听到市场状态变化防止闪烁
              this.isStartNum++ // 判断是否是首次进入页面 0 代表首次进入本页面 每次++
            })
            // this.CommodityHighLow = response.data.value
          }
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
#transcc_new_NewTransccTopLine {
  height: 100%;
  /deep/ .el-row {
    height: 100%;
  }
  /deep/.el-drawer {
    width:500px!important;
  }
  /deep/.el-drawer__header{
    display: none;
  }
  .coinfoWrap  /deep/.el-dialog{
    background-color:#2C2C2C!important;
    .el-dialog__header{
      display: none;
    }
    .el-dialog__body{
      padding:0;
    }
    .el-dialog__footer{
      text-align:center;
      .el-button{
        height: 40px;
        background: #E6F1FC;
        border-radius: 4px;
        border: 1px solid #A3D0FD;
        border:none;
        span{
          color:#A3D0FD;
        }
      }
      .el-button--primary{
        background-color:#0486FE;
        span{
          color:#fff;
        }
      }
    }

  }
  .good_icon {
    margin-left: 37px;
    height: 32px;
    // font-weight: 500;
    line-height: 32px;
    font-family: Source Han Sans SC;
    font-weight: bold;
    font-size: 14px;
    color: #DFDFDF;
  }
  .good_name {
    height: 32px;
    // font-size: 23px;
    // font-family: PingFangSC-Medium, PingFang SC;
    // font-weight: 500;
    // color: #00edf4;
    line-height: 32px;
    font-family: Source Han Sans SC;
    font-weight: bold;
    font-size: 14px;
    color: #DFDFDF;
  }
  .good_msg {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .good_msg_t {
    font-family: Source Han Sans SC;
    font-weight: 400;
    font-size: 14px;
    color: #989898;
    }
    .good_msg_v {
      // height: 32px;
      font-family: Source Han Sans SC;
      font-weight: 500;
      font-size: 14px;
      color: #DFDFDF;
      margin-left: 6px;
    }
    .red {
      color: #d94066;
    }
    .blood{
      color: #d94066;
    }
    .green{
      color: #00FF0E;
    }
    .big{
      font-size: 14px;
      font-weight: 500;
    }
  }
  .marketType {
    min-width: 100px;
    height: 33px;
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #d94066;
    line-height: 33px;
    text-align: center;
  }
  .time {
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.9);
    line-height: 25px;
    white-space:nowrap;
    // overflow:hidden;
    // text-overflow:ellipsis;
  }
  /deep/.item-align-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .btn {
    width: 56px;
    height: 28px;
    padding:0;
    border-radius: 4px;
    border: 1px solid #2483ff;
    line-height: 28px;
    text-align: center;
    cursor: pointer;
    font-family: Source Han Sans SC;
    font-weight: bold;
    font-size: 22px;
    color: #DFDFDF;
  }
  .header-row{
    display: flex;
    justify-content: space-between;
    .el-col-24{
    
      flex: 1;
      white-space:nowrap;
      text-overflow: ellipsis;
    }
    .el-col-24~.el-col-24{
      
    }
    .good_cell-1{
      flex: 30 30 30px;
    }
    .good_cell-2{
      position: relative;
      // flex: 88 88 88px;
      
    }
    .good_cell-3{
      // flex: 102 102 102px;
      margin-right: 14px;
      /deep/ .el-input__inner{
        background: transparent;
        border: none;
        font-family: Source Han Sans SC;
        font-weight: 400;
        font-size: 14px;
        padding: 0;
        color: #DFDFDF;
        width: 120px;
      }
    }
    //新增————————
    .el-col-14{
      width: auto;
    }
    .marketType{
      font-family: Source Han Sans SC;
      font-weight: 400;
      font-size: 14px;
      color: #d94066;
    }
    .time{
      font-family: Source Han Sans SC;
      font-weight: 400;
      font-size: 14px;
      color: #C7C7C7;
    }
    .good_cell_left{

      text-align: center;
      display: flex;
      align-items: center;
      font-family: Source Han Sans SC;
      font-weight: bold;
      font-size: 20px;
      color: #DFDFDF;
      margin-right: 29px;
      .btn{
        width: 26px;
        height: 26px;
        background: #393939;
        border-radius: 4px;
        border: 1px solid #FFFFFF;
        text-align: center;
        line-height: 26px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        font-size: 12px;
        color: #DFDFDF;
      }
    }
    .good_cell_center{
      display: flex;
      justify-content: flex-start;
      flex:3;
      .el-col{
        flex-grow: 0;
      }
      & > div{
          margin-right: 29px;
      }
    }
    .good_cell_right{
      height: 100%;
      display: flex;
     
      justify-content: center;
      align-items: center;
    }
     //新增————————
    .good_cell-4{
      
    }
    .good_cell-5{
      // flex: 116 116 116px;
    }
    .good_cell-6{
      // flex: 70 70 70px;
    }
    .good_cell-7{
      // flex: 120 120 120px;
    }
    // .good_cell-1{
    //   flex: 56 56 56px;
    // }
  }
}
</style>
<style lang="scss">
._ccStyle .el-select-dropdown__item.selected{
  color: #989898;
  font-weight: 700;
}
</style>